import Services from '../../services';

import { message } from 'antd';

export default class Service extends Services {
  getResumoIndicadores = async (dataInicial, dataFinal, idEmpresa) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const url = `${this.endPoint}Graficos/dadoResumoIndicadores/${dataInicial}/${dataFinal}/${idEmpresa}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
      });

      // Ver comentario em Nps/Service.js - mesmo cuidado com 403 de corpo
      // vazio (usuario restrito por unidade, 2026-08-11).
      if (response.status === 403) {
        message.error('Você não tem permissão para ver os dados dessa seleção.');
        return null;
      }

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  listCompany = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };
}
